<template>
	<div v-if="isAdmin" class="fixed bottom-4 left-4 z-50">
		<!-- Admin Mode Toggle -->
		<button
			@click="toggleAdminMode"
			class="rounded-full w-10 h-10 flex items-center justify-center transition-all duration-200 backdrop-blur-sm"
			:class="adminMode
				? 'bg-[--rot] bg-opacity-80 hover:bg-opacity-100 text-white'
				: 'bg-black bg-opacity-30 hover:bg-opacity-50 text-white'"
			:aria-label="adminMode ? 'Admin-Modus deaktivieren' : 'Admin-Modus aktivieren'"
		>
			<v-icon name="ri-pencil-fill" class="w-5 h-5" fill="currentColor" />
		</button>

	</div>
</template>

<script setup lang="ts">
import { useAdminEdit } from '~/composables/useAdminEdit'

const { isAdmin, adminMode, toggleAdminMode } = useAdminEdit()
</script>
